import { cn } from '@/lib/utils'

const SIZES = {
  sm: {wrapper: 'w-8 h-8', text: 'text-xs'},
  lg: {wrapper: 'w-20 h-20', text: 'text-xl'},
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return parts[0][0].toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function Avatar({ name, avatarUrl, size = 'sm' }: { name: string; avatarUrl?: string | null; size?: 'sm' | 'lg' }) {
  const {wrapper, text} = SIZES[size]

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name}
        className={cn(wrapper, 'rounded-full object-cover flex-shrink-0')}
      />
    )
  }
  return (
    <div className={cn(wrapper, 'rounded-full bg-muted flex items-center justify-center flex-shrink-0')}>
      <span className={cn(text, 'font-medium text-muted-foreground')}>{initials(name)}</span>
    </div>
  )
}
